const tags = {
  MATERIAL : '#684D92', // 재료 
  PROCESS : '#0F64CE', // 공정 
  MEASUREMENT : '#207486', // 측정목적 
  ANALYSIS : '#5D9C3D', // 분석목적
} ; 
const tagsArr = [
  {
    type : 'MATERIAL' , 
    color : '#684D92',
    name : '재료' , 
  } , 
  {
    type : 'PROCESS' , 
    color : '#0F64CE',
    name : '공정' , 
  } , 
  {
    type : 'EQUIPMENT' ,
    color : '#5D9C3D',
    name : '측정/분석' ,
  } ,
] ; 

export default {
  tags , 
} ; 

export {
  tags , 
  tagsArr , 
}